/*
 * エラー画面
 */
const route = {
    name: "Error",
    path: "*",
    view: "Error",
    component: () =>
        import ("../ErrorView.vue"),
    meta: {
        title: "エラー"
    }
}

export default route;